import * as React from 'react'
import styled from 'styled-components'

const Wrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.625rem;
`

export const AvatarStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 100%;
  cursor: pointer;
  background: #1936d0;

  span {
    background: #1936d0;
    color: white;
  }
`

const AvatarImageStyled = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 100%;
`

const AvatarFallbackStyled = styled.div`
  border-radius: 100%;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.625rem;
  font-weight: 700;
  line-height: 0.875rem;
  background: #1936d0;
  color: white;
`

// Function to determine if the cloudinaryId represents a placeholder or an invalid URL
export const isPlaceholderOrInvalid = (
  cloudinaryId: string | undefined,
  cloudinaryType: string | undefined
) => {
  return (
    !cloudinaryId ||
    (cloudinaryType === 'fetch' && decodeURIComponent(cloudinaryId).startsWith('placeholders'))
  )
}

export const getTwoLetter = (name?: string) => {
  if (!name) {
    return ''
  }

  const splittedName = name.toUpperCase().split(' ')

  return splittedName.length > 1
    ? splittedName[0].charAt(0) + splittedName[1].charAt(0)
    : splittedName[0].charAt(0)
}

export interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  alt: string
  onClick?: () => void
  imageSrc?: string
  displayFallback?: boolean
}

const Avatar: React.FC<AvatarProps> = ({ alt, onClick, imageSrc, displayFallback }) => {
  return (
    <Wrap onClick={onClick}>
      <AvatarStyled>
        {!displayFallback ? (
          <AvatarImageStyled src={imageSrc} alt={alt} />
        ) : (
          <AvatarFallbackStyled>{getTwoLetter(alt)}</AvatarFallbackStyled>
        )}
      </AvatarStyled>
    </Wrap>
  )
}

export default Avatar



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/Navigation/Avatar.tsx